// src/App.jsx
import React, { useState, useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Home } from './Home';
import { Users } from './Users';
import { Navigation } from './Navigation';
import Login from './forms/login';
//import Register from './forms/register';
import ServiceProfile from './components/ServiceProfile/ServiceProfile';
import AppointmentsTrai from './AppointmentsTrai';
import Services from './Services';
import Booking from './Booking';
import Bookings from './Bookings';
//import ForgotPassword from './forms/ForgotPassword';
//import ResetPassword from './forms/ResetPassword';
import BookingDetails from './BookingDetails';
import Statistics from './Statistics';
import { apiRequest, getAccessToken } from './utils';
import Notifications from "./Notifications";
import PrivacyPolicy from "./forms/PrivacyPolicy";
import OAuthBridge from './pages/OAuthBridge';
import GoogleSuccess from './forms/GoogleSuccess';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    // ha van token, tekintsük belépettnek
    return !!getAccessToken() || localStorage.getItem('isLoggedIn') === 'true';
  });
  const [username, setUsername] = useState(() => (localStorage.getItem('username') || ''));
  const [userType, setUserType] = useState(null);

  // Állapot perzisztálás
  useEffect(() => {
    localStorage.setItem('isLoggedIn', isLoggedIn ? 'true' : 'false');
  }, [isLoggedIn]);

  useEffect(() => {
    localStorage.setItem('username', username || '');
  }, [username]);

  // user type betöltése
  useEffect(() => {
    if (isLoggedIn) {
      apiRequest(`${process.env.REACT_APP_API}/api/user-profile/`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      })
        .then(res => res.json())
        .then(data => {
          const uType = data.user_data?.user_type?.toLowerCase() || null;
          setUserType(uType);
          if (uType) localStorage.setItem('user_type', uType);
        })
        .catch(err => {
          console.error("Hiba a user type lekérésénél:", err);
          setUserType(localStorage.getItem('user_type') || null);
        });
    } else {
      setUserType(null);
      localStorage.removeItem('user_type');
    }
  }, [isLoggedIn]);

  // Gyökér route logika
  const rootElement = (() => {
    if (!isLoggedIn) return <Navigate to="/services" replace />;
    if (!userType) return <div />; // lehet spinner
    if (userType === 'provider') return <Navigate to="/AppointmentsTrai/Appointments" replace />;
    return <Navigate to="/services" replace />;
  })();

  return (
    <BrowserRouter>
      <div className="App">
        <Navigation
          isLoggedIn={isLoggedIn}
          setIsLoggedIn={setIsLoggedIn}
          username={username}
          setUsername={setUsername}
        />
        <div className="container mt-5 p-4 shadow rounded">
          <Routes>
            <Route path="/" element={rootElement} />
            <Route path="/oauth-done" element={<OAuthBridge setIsLoggedIn={setIsLoggedIn} setUsername={setUsername} />} />
            <Route path="/Home" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/users" element={<Users />} />
            <Route path="/login" element={<Login setIsLoggedIn={setIsLoggedIn} setUsername={setUsername} />} />
            {/* <Route path="/register" element={<Register />} /> */}
            <Route path="/serviceprofile/*" element={<ServiceProfile />} />
            <Route path="/AppointmentsTrai/*" element={<AppointmentsTrai />} />
            <Route path="/booking/:userId/:serviceId" element={<Booking />} />
            <Route path="/bookings" element={<Bookings />} />
            <Route path="/booking-details/:userId/:serviceId/:bookingDate" element={<BookingDetails />} />
            {/* <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:uid/:token" element={<ResetPassword />} /> */}
            <Route path="/statistics" element={<Statistics />} />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route
              path="/oauth-success"
              element={
                <GoogleSuccess
                  setIsLoggedIn={setIsLoggedIn}
                  setUsername={setUsername}
                />
              }
            />
          </Routes>
        </div>
      </div>
    </BrowserRouter>
  );
}

export default App;
